export const createWaitingListItemFrag = `
    id
`;

export const updateWaitingListItemFrag = `
    id
`;

export const contractDetailFrag = `
    id
    validFrom
    validTo
    cancellationDate
    extendedValidTo
    offers {
        id
        dateFrom
        dateTo
        usualTime
        frequency
        offerId
        offer {
            id
            code
            name
            unit            
            color
        }
        operations
        procedures
    }
`;

export const upsertContractOffersFrag = `
    offers {
        id
    }
`;
